var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "bairun-absolute-container bairun-bianlidian-sale" },
    [
      _c("el-header", { staticClass: "bairun-header" }, [
        _c(
          "div",
          { staticClass: "search-term" },
          [
            _c(
              "el-form",
              { attrs: { inline: true } },
              [
                _c(
                  "el-popover",
                  {
                    directives: [
                      {
                        name: "mobile",
                        rawName: "v-mobile",
                        value: true,
                        expression: "true"
                      }
                    ],
                    attrs: { placement: "right-end", trigger: "click" },
                    model: {
                      value: _vm.showSelSeller,
                      callback: function($$v) {
                        _vm.showSelSeller = $$v
                      },
                      expression: "showSelSeller"
                    }
                  },
                  [
                    _vm.sellerOptions.length > 1
                      ? _c(
                          "el-radio-group",
                          {
                            staticClass: "bairun-search-sellers",
                            attrs: { size: "mini" },
                            on: { change: _vm.onSubmit },
                            model: {
                              value: _vm.searchInfo.sellerId,
                              callback: function($$v) {
                                _vm.$set(_vm.searchInfo, "sellerId", $$v)
                              },
                              expression: "searchInfo.sellerId"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: 0, border: "" } },
                              [_vm._v("总")]
                            ),
                            _vm._l(_vm.sellerOptions, function(item) {
                              return _c(
                                "el-radio",
                                { attrs: { label: item.sellerId, border: "" } },
                                [_vm._v(_vm._s(item.shortSellerName))]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      { attrs: { slot: "reference" }, slot: "reference" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("getSellerShortName")(
                              _vm.searchInfo.sellerId
                            )
                          )
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm.sellerOptions.length > 1
                  ? _c(
                      "el-radio-group",
                      {
                        directives: [
                          {
                            name: "mobile",
                            rawName: "v-mobile",
                            value: false,
                            expression: "false"
                          }
                        ],
                        staticClass: "bairun-search-sellers",
                        attrs: { size: "mini" },
                        on: { change: _vm.onSubmit },
                        model: {
                          value: _vm.searchInfo.sellerId,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "sellerId", $$v)
                          },
                          expression: "searchInfo.sellerId"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: 0, border: "" } }, [
                          _vm._v("总")
                        ]),
                        _vm._l(_vm.sellerOptions, function(item) {
                          return _c(
                            "el-radio",
                            { attrs: { label: item.sellerId, border: "" } },
                            [_vm._v(_vm._s(item.shortSellerName))]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.searchInfo.timeTag !== "custom"
                  ? _c(
                      "div",
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd 00:00:00",
                            placeholder: "日期选择",
                            clearable: false
                          },
                          on: { change: _vm.onSubmit },
                          model: {
                            value: _vm.searchInfo.dateTime,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "dateTime", $$v)
                            },
                            expression: "searchInfo.dateTime"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.searchInfo.timeTag === "custom"
                  ? _c(
                      "div",
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd 00:00:00",
                            placeholder: "日期选择",
                            clearable: false
                          },
                          on: { change: _vm.onSubmit },
                          model: {
                            value: _vm.searchInfo.startTime,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "startTime", $$v)
                            },
                            expression: "searchInfo.startTime"
                          }
                        }),
                        _vm._v("- "),
                        _c("el-date-picker", {
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd 23:59:59",
                            placeholder: "日期选择",
                            clearable: false,
                            "picker-options": _vm.endTimePickerOptions
                          },
                          on: { change: _vm.onSubmit },
                          model: {
                            value: _vm.searchInfo.endTime,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "endTime", $$v)
                            },
                            expression: "searchInfo.endTime"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "mini" },
                    on: { change: _vm.onCheckTime },
                    model: {
                      value: _vm.searchInfo.timeTag,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "timeTag", $$v)
                      },
                      expression: "searchInfo.timeTag"
                    }
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "date" } }, [
                      _vm._v("当日")
                    ]),
                    _c("el-radio-button", { attrs: { label: "week" } }, [
                      _vm._v("当周")
                    ]),
                    _c("el-radio-button", { attrs: { label: "month" } }, [
                      _vm._v("当月")
                    ]),
                    _c("el-radio-button", { attrs: { label: "year" } }, [
                      _vm._v("当年")
                    ]),
                    _c("el-radio-button", { attrs: { label: "custom" } }, [
                      _vm._v("自定义")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("el-main", { staticClass: "bairun-main" }, [
        _c("div", { staticClass: "bairun-padding bairun-margin-b-large" }, [
          _c(
            "div",
            [
              _c("div", { staticClass: "divider-title" }, [
                _c("span", { staticClass: "bairun-margin-r" }, [
                  _vm._v("销售汇总")
                ])
              ]),
              _c("el-divider"),
              _c("el-alert", { attrs: { type: "success", closable: false } }, [
                _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                  _vm._v(
                    " 总销售额：" +
                      _vm._s(_vm.echartsSaleTotalMoney) +
                      "元    总销量：" +
                      _vm._s(_vm.echartsSaleTotalNum) +
                      "件 "
                  )
                ])
              ]),
              _c("div", {
                staticClass: "bairun-margin-t",
                staticStyle: { width: "100%", height: "30rem" },
                attrs: { id: "echartsSaleTotal" }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bairun-margin-t-large" },
            [
              _c(
                "div",
                { staticClass: "divider-title" },
                [
                  _c("span", { staticClass: "bairun-margin-r" }, [
                    _vm._v("站点分析")
                  ]),
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "mini" },
                      on: { change: _vm.onCheckTab },
                      model: {
                        value: _vm.checkTab,
                        callback: function($$v) {
                          _vm.checkTab = $$v
                        },
                        expression: "checkTab"
                      }
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "qushi" } }, [
                        _vm._v("趋势")
                      ]),
                      _c("el-radio-button", { attrs: { label: "zhanbi" } }, [
                        _vm._v("占比")
                      ]),
                      _c("el-radio-button", { attrs: { label: "paihang" } }, [
                        _vm._v("排行")
                      ])
                    ],
                    1
                  ),
                  _vm.checkTab === "paihang"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "right",
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-download"
                          },
                          on: { click: _vm.onDownloadPaihang }
                        },
                        [_vm._v("下载")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("el-divider")
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTab === "qushi",
                  expression: "checkTab === 'qushi'"
                }
              ],
              staticClass: "bairun-margin-t"
            },
            [
              _c("div", {
                staticClass: "bairun-margin-t",
                staticStyle: { width: "100%", height: "30rem" },
                attrs: { id: "echartsQuShi" }
              })
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTab === "zhanbi",
                  expression: "checkTab === 'zhanbi'"
                }
              ],
              staticClass: "bairun-margin-t"
            },
            [
              _c("div", {
                staticStyle: { width: "100%", height: "30rem" },
                attrs: { id: "echartsZhanBi" }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.zhanbiTable.show === "xiaoshoue",
                      expression: "zhanbiTable.show === 'xiaoshoue'"
                    }
                  ]
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.zhanbiTable.table,
                        "default-sort": {
                          prop: "totalTradePay",
                          order: "descending"
                        }
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "类目", prop: "categoryName" }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "销售额(元)", prop: "totalTradePay" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(scope.row.totalTradePay.toFixed(2))
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "占比", prop: "totalTradePayPercent" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        scope.row.totalTradePayPercent * 100
                                      ).toFixed(2)
                                    ) + "%"
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.zhanbiTable.show === "xiaoliang",
                      expression: "zhanbiTable.show === 'xiaoliang'"
                    }
                  ]
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.zhanbiTable.table,
                        "default-sort": {
                          prop: "totalGoodsNum",
                          order: "descending"
                        }
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "类目", prop: "categoryName" }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "销量(件)", prop: "totalGoodsNum" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [
                                  _vm._v(_vm._s(scope.row.totalGoodsNum))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "占比", prop: "totalGoodsNumPercent" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        scope.row.totalGoodsNumPercent * 100
                                      ).toFixed(2)
                                    ) + "%"
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTab === "paihang",
                  expression: "checkTab === 'paihang'"
                }
              ],
              staticClass: "bairun-margin-t"
            },
            [
              _c(
                "el-divider",
                {
                  staticClass: "bairun-divier-hide",
                  attrs: { "content-position": "center" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-rate", {
                        staticStyle: { display: "inline-block" },
                        attrs: {
                          value: 1,
                          max: 1,
                          disabled: "",
                          "text-color": "#ff9900"
                        }
                      }),
                      _c("div", { staticStyle: { "white-space": "nowrap" } }, [
                        _vm._v("销量top 50排行榜 ")
                      ]),
                      _c("el-rate", {
                        staticStyle: { display: "inline-block" },
                        attrs: {
                          value: 1,
                          max: 1,
                          disabled: "",
                          "text-color": "#ff9900"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { "show-header": false, data: _vm.paihangTable.table }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "商品名称", prop: "goodsName" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.goodsName))]),
                            _c("div", [
                              _vm._v(
                                _vm._s(scope.row.goodsSpecification) +
                                  "/" +
                                  _vm._s(scope.row.goodsUnit)
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "类目", prop: "categoryName" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.categoryName))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "销量排名" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                "已售：" +
                                  _vm._s(scope.row.totalGoodsNum) +
                                  "件"
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }